import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import Header from '../Header';
import Footer from '../Footer';
import SocialSidebar from '../SocialSidebar';

export const PublicLayout = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Header />
      <Box sx={{ flex: 1 }}>
        <Outlet />
      </Box>
      <Footer />
      <SocialSidebar />
    </Box>
  );
};
